import { render } from "./InputTextNewTheme.vue?vue&type=template&id=4c9c7c01&scoped=true"
import script from "./InputTextNewTheme.vue?vue&type=script&lang=js"
export * from "./InputTextNewTheme.vue?vue&type=script&lang=js"

import "./InputTextNewTheme.vue?vue&type=style&index=0&id=4c9c7c01&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9c7c01"]])

export default __exports__